import axios from "axios";
import React, { useEffect, useState } from "react";
import { API_URL } from "utils/ApiUrl";

const useFetchUserStats = () => {
  const [userStats, setUserStats] = useState();

  const fetchUserStats = async () => {
    const accessToken = localStorage.getItem("accessToken");

    try {
      const response = await axios.get(`${API_URL}/users/user-stats`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = response?.data?.data;
      console.log("user Stats : ", response);
      setUserStats(data);
    } catch (e) {
      if (e?.response) console.log("Error response User Stats :", e?.response);
      else console.error("Error during API call User Stats :", e);
    }
  };

  useEffect(() => {
    fetchUserStats();
  }, []);

  return userStats;
};

export default useFetchUserStats;
